import { http } from 'http';

export default {
  sendReadedNotification: (driverIdEncrypted, notificationIdEncrypted) =>
    http.put(
      `/driversweb/drivers/notifications/readed?driverId=${driverIdEncrypted}&notificationId=${notificationIdEncrypted}`
    )
};
